export default __webpack_public_path__ + "static/media/img5.63e1a7dd.jpg";